let PaginacionConfig = {
   
    CANTIDAD_REGISTROS: 10,
    CANTIDAD_REGISTROS_FACETA: 5,
    MAXIMO_PAGINAS: 4
}

export default PaginacionConfig;


// WEBPACK FOOTER //
// ./src/busqueda/config/paginacion.config.js